let sliders = {
    init: function () {
        $('#hero_banner').not('slick-initialized').slick({
            fade: true,
            infinite: true,
            dots: true,
            appendDots: $('.banner-dots'),
            arrows: true,
            appendArrows: $('.banner-controls'),
            prevArrow: '<div class="arrow-prev"><i class="far fa-arrow-left"></i></div>',
            nextArrow: '<div class="arrow-next"><i class="far fa-arrow-right"></i></div>',
            adaptiveHeight: true,
        });
        $('.videos-carousel-wrap').not('slick-initialized').slick({
            fade: false,
            infinite: true,
            arrows: true,
            appendArrows: $('.videos-carousel-controls'),
            prevArrow: '<div class="arrow-prev"><i class="far fa-arrow-left"></i></div>',
            nextArrow: '<div class="arrow-next"><i class="far fa-arrow-right"></i></div>',
            adaptiveHeight: true,
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });

        $('#featured_post_banner').not('slick-initialized').slick({
            fade: true,
            infinite: true,
            dots: true,
            appendDots: $('.banner-dots'),
            arrows: true,
            appendArrows: $('.banner-controls'),
            prevArrow: '<div class="arrow-prev"><i class="far fa-arrow-left"></i></div>',
            nextArrow: '<div class="arrow-next"><i class="far fa-arrow-right"></i></div>',
            adaptiveHeight: true,
        });

        $('#featured_event_banner').not('slick-initialized').slick({
            fade: true,
            infinite: true,
            dots: true,
            appendDots: $('.banner-dots'),
            arrows: true,
            appendArrows: $('.banner-controls'),
            prevArrow: '<div class="arrow-prev"><i class="far fa-arrow-left"></i></div>',
            nextArrow: '<div class="arrow-next"><i class="far fa-arrow-right"></i></div>',
            adaptiveHeight: true,
        });

        $('.testimonials').not('slick-initialized').slick({
            fade: true,
            infinite: true,
            dots: true,
            appendDots: $('.testimonial-dots'),
            arrows: true,
            appendArrows: $('.testimonial-controls'),
            prevArrow: '<div class="arrow-prev"></div>',
            nextArrow: '<div class="arrow-next"></div>',
            adaptiveHeight: true,
        });
    },
    breakdown: () => {
        $('#hero_banner.slick-initialized').slick("#F8F8F7unslick");
        $('.testimonials.slick-initialized').slick("unslick");
    },
};


import simpleParallax from 'simple-parallax-js';

$(document).ready(function () {
    let Sliders = Object.create(sliders);
    Sliders.init();


    /* add parallax effect
     * for config options see: https://github.com/geosigno/simpleParallax.js#settings
     */
    // const parallax = document.querySelectorAll('#hero_banner.slick-initialized img');
    // new simpleParallax(parallax);
});
